import { useFragmentsDeliveryAPIStationConfigClientGetConfig } from '@mi-front/api-clients';
import { Info, QueryView } from '@mi-front/ui';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Alert } from '@mui/material';
import { useFragmentCtx } from '../../../../context/fragment-ctx';
import { DeliveryStatusInfo } from './DeliveryStatusInfo';

import { FormattedMessage } from 'react-intl';
export const FragmentDeliveryStatus = () => {
  const fragment = useFragmentCtx();

  const configQuery = useFragmentsDeliveryAPIStationConfigClientGetConfig(fragment.stationId);

  return (
    <Info
      title={
        <>
          <FileUploadIcon />{' '}
          <FormattedMessage id="fragments.exportStatus.title" defaultMessage="External export" />
        </>
      }
      data={
        <QueryView
          query={configQuery}
          children={(data) => {
            return !data?.enabled ? (
              <div>
                <Alert severity="warning">
                  <FormattedMessage
                    id="fragments.exportStatus.externalExportNotEnabled"
                    defaultMessage="El export externo no está habilitado, contacte a soporte."
                  />
                </Alert>
              </div>
            ) : (
              <DeliveryStatusInfo fragment={fragment} />
            );
          }}
        />
      }
    />
  );
};
